













import { Vue, Component } from 'vue-property-decorator'
import { VueMetaInfo } from '~base/common/types'
import MitmachenForm from '~components/mitmachen/form.vue'

@Component({
  head(): VueMetaInfo {
    const title = this.$t('seo.title.mitmachen').toString()
    const description = this.$t('seo.description.mitmachen').toString()
    return {
      title,
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex,follow' },
        { hid: 'description', name: 'description', content: description },
        { hid: 'og:title', name: 'og:title', content: title },
        { hid: 'og:description', name: 'og:description', content: description },
      ],
    }
  },
  layout: 'mitmachen',
  components: {
    MitmachenForm,
  },
})
export default class MitmachenPage extends Vue {
  protected codeError: boolean = false
}
